import { informationDestroyMutation, informationListQueryKey } from '@crm/api'
import { ConfirmModal } from '@crm/components'
import {
  useInvalidatePredicateQueries,
  useResetPagination
} from '@shared/hooks'
import { useLocales } from '@shared/locales'
import { useMutation } from '@tanstack/react-query'
import { notification } from 'antd'

interface DeleteInformationProps {
  isOpen: boolean
  onClose: () => void
  id?: number | null
}

export const DeleteInformation = ({
  isOpen,
  onClose,
  id
}: DeleteInformationProps) => {
  const { t } = useLocales()
  const { invalidateQueries } = useInvalidatePredicateQueries()
  const { resetPagination } = useResetPagination()

  const { mutate, isPending } = useMutation({
    ...informationDestroyMutation(),
    onSuccess: () => {
      invalidateQueries([informationListQueryKey()])
      resetPagination()
      onClose()
      notification.success({
        message: t('success.success'),
        description: t('success.success')
      })
    }
  })

  return (
    <ConfirmModal
      open={isOpen}
      onSuccess={() => mutate({ path: { id: Number(id) } })}
      onCancel={onClose}
      confirmLoading={isPending}
    />
  )
}
